<template>
  <div>
  	<Slide />
  	<Download />
  </div>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Download from '@/components/Download.vue'

export default {
  name: 'downloads',
  components: {
    Slide,
    Download
  }
}
</script>
